module.exports = __webpack_public_path__ + "img/dsci0034.e0b8a6df.jpg";